import React from 'react';
import * as S from './styles';

type Props = {
  amount?: number;
  mode?: 'grid' | 'row';
  rows?: number;
  height?: string | number;
  mediaPosition?: number;
  showMedia?: boolean;
};

const Placeholder = ({
  amount = 1,
  rows = 5,
  mode = 'grid',
  height = 'auto',
  mediaPosition = 0,
  showMedia = true,
}: Props) => (
  <S.Placeholder data-test="Placeholder">
    {[...new Array(amount)].map((e, i) => (
      <S.Deal key={i.toString()} mode={mode} height={height}>
        {showMedia && <S.Media mediaPosition={mediaPosition} mode={mode} />}
        <S.Rows mode={mode}>
          {[...new Array(rows)].map((row, rowIndex) => (
            <S.Text key={rowIndex.toString()} rowIndex={rowIndex} mode={mode} />
          ))}
        </S.Rows>
      </S.Deal>
    ))}
  </S.Placeholder>
);

export default Placeholder;
